export const REHYDRATE_DONE = 'REHYDRATE_DONE';
export const REHYDRATE_TRIGGER_WAITING = 'REHYDRATE_TRIGGER_WAITING';
export const REHYDRATE_START = 'persist/REHYDRATE';



// WEBPACK FOOTER //
// ./src/actions/rehydrate.js